import React from 'react'
import { Select } from '@ztechapps/webui.input'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import find from 'lodash/find'
import { useTemplateList } from '@ztechapps/common.hook'

export const CustomerDiscountSelect = ({ value, ...rest }) => {
  //get the templates,

  const { list } = useTemplateList({
    filter: {
      category: 'discount_template',
    },
  })

  const options = React.useMemo(() => {
    if (!isEmpty(list)) {
      return map(list, (item) => {
        return {
          label: item?.name,
          value: item?._id,
        }
      })
    }
  }, [list])

  const newValue = React.useMemo(() => {
    return find(options, (item) => {
      return item?.value === value
    })
  }, [options, value])

  return (
    <Select
      {...{
        ...rest,
        value: newValue,
        options,
      }}
    />
  )
}
